import { Module } from "vuex";

const themeModule: Module<any, any> = {
  state() {
    return {
      loading: false,
      print: false,
      mobile: false,
      language: null,
      reportScale: null,
    };
  },
  getters: {
    loading: (state) => state.loading,
    print: (state) => state.print,
    mobile: (state) => state.mobile,
    language: (state) => state.language,
    reportScale: (state) => state.reportScale,
  },
  mutations: {
    SET_LOADING: (state, data) => {
      state.loading = data;
    },
    SET_PRINT: (state, data) => {
      state.print = data;
    },
    SET_MOBILE: (state, data) => {
      state.mobile = data;
    },
    SET_LANGUAGE: (state, data) => {
      state.language = data;
    },
    SET_REPORT_SCALE: (state, data) => {
      state.reportScale = data;
    },
  },
};

export default themeModule;
